
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/submission-complete",
      function () {
        return require("private-next-pages/submission-complete/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/submission-complete"])
      });
    }
  